export const BASE_URL = window.location.hostname==='localhost'? 'http://127.0.0.1:9090': process.env.REACT_APP_API_BASE_URL
